export default __webpack_public_path__ + "static/media/Asset 3.8c79f0d6.png";